// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete-container-Jv_sp {
  position: relative;
  --top-popup: 52px;
}

.autocomplete-label-sg3UR {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.autocomplete-content-tB5yB {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #666666;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  padding: 0px 12px;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.autocomplete-content-tB5yB:focus-within { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.autocomplete-disabled-P1K6Q {
  opacity: 0.5;
  pointer-events: none;
}

.autocomplete-icon-dg9l_ {
  --size: 22px;
  flex-shrink: 0;
  margin-right: 8px;
}

.autocomplete-input-JWvdB {
  height: 100%;
  width: 100%;
  display: block;
  flex-grow: 1;
  font-size: 15px;
  font-family: Roboto;
  border: none;
  border-radius: 4px;
  outline: none;
  padding: 0px;
}

.autocomplete-input-JWvdB:disabled {
  background-color: transparent;
}

.autocomplete-input-JWvdB::placeholder {
  color: var(--color-neutral-500);
}

.autocomplete-clear-TPB0H {
  --size: 20px;
  flex-shrink: 0;
}

.autocomplete-hint-pAMSa {
  font-size: 14px;
  margin-top: 16px;
  margin-left: 4px;
}

.autocomplete-active-n8Jz8 {
  color: black;
  font-size: 15px;
}

.autocomplete-value-rlAPY {
  flex: 1;
}

.autocomplete-expandMoreIcon-S2iMr {
  --size: 22px;
}

.autocomplete-popup-Sa1eS {
  background-color: white;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/autocomplete/autocomplete.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".container {\n  position: relative;\n  --top-popup: 52px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.content {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  color: #666666;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  padding: 0px 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.content:focus-within { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.icon {\n  --size: 22px;\n  flex-shrink: 0;\n  margin-right: 8px;\n}\n\n.input {\n  height: 100%;\n  width: 100%;\n  display: block;\n  flex-grow: 1;\n  font-size: 15px;\n  font-family: Roboto;\n  border: none;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px;\n}\n\n.input:disabled {\n  background-color: transparent;\n}\n\n.input::placeholder {\n  color: var(--color-neutral-500);\n}\n\n.clear {\n  --size: 20px;\n  flex-shrink: 0;\n}\n\n.hint {\n  font-size: 14px;\n  margin-top: 16px;\n  margin-left: 4px;\n}\n\n.active {\n  color: black;\n  font-size: 15px;\n}\n\n.value {\n  flex: 1;\n}\n\n.expandMoreIcon {\n  --size: 22px;\n}\n\n.popup {\n  background-color: white;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `autocomplete-container-Jv_sp`,
	"label": `autocomplete-label-sg3UR`,
	"content": `autocomplete-content-tB5yB`,
	"disabled": `autocomplete-disabled-P1K6Q`,
	"icon": `autocomplete-icon-dg9l_`,
	"input": `autocomplete-input-JWvdB`,
	"clear": `autocomplete-clear-TPB0H`,
	"hint": `autocomplete-hint-pAMSa`,
	"active": `autocomplete-active-n8Jz8`,
	"value": `autocomplete-value-rlAPY`,
	"expandMoreIcon": `autocomplete-expandMoreIcon-S2iMr`,
	"popup": `autocomplete-popup-Sa1eS`
};
export default ___CSS_LOADER_EXPORT___;
